import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import translations from './translations';

const LanguageContext = createContext();

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem('jc-lang');
    if (stored === 'es' || stored === 'en') return stored;
  } catch (_) {
    // ignore
  }
  return 'es';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getStoredLanguage);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    try {
      localStorage.setItem('jc-lang', newLang);
    } catch (_) {
      // ignore
    }
  }, []);

  const t = useCallback(
    (key) => {
      const keys = key.split('.');
      let result = translations[lang];
      for (const k of keys) {
        if (result && typeof result === 'object' && k in result) {
          result = result[k];
        } else {
          return key;
        }
      }
      return result;
    },
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
